import { render, staticRenderFns } from "./admin-login.vue?vue&type=template&id=83f76c66"
import script from "./admin-login.vue?vue&type=script&lang=js"
export * from "./admin-login.vue?vue&type=script&lang=js"
import style0 from "./admin-login.vue?vue&type=style&index=0&id=83f76c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports